import Api from './axiosInstance'
import { API_PRICING } from 'utils/constants'

type FetchPricingParams = {
  limit: number
  page: number
  search?: string
  filters?: any
}

// To fetch all pricing data
const fetchPricings = ({
  limit,
  page,
  search,
  filters,
}: FetchPricingParams) => {
  let options: any = {}

  if (search) {
    options.search = search
  }

  if (filters) {
    options = { ...options, ...filters }
  }

  const params = new URLSearchParams({
    limit,
    page,
    ...options,
  })

  return Api.get({
    url: `${API_PRICING.PRICING}?${params}`,
  })
}

// To fetch individual pricing pricing data
const getPricingDetails = (id?: string) => {
  return Api.get({
    url: `${API_PRICING.PRICING}/${id}`,
  })
}

// To update individual pricing pricing data
const updatePricingDetails = (id: string, data: Record<string, any>) => {
  return Api.patch({
    url: `${API_PRICING.PRICING}/${id}`,
    data,
  })
}

// To Upload a Pricing file in server and update Pricing data
const importPricingData = async (data: any) => {
  return Api.post({
    url: API_PRICING.PRICING_IMPORT,
    data: data,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

// To Upload a Pricing file in server and update Pricing data
const exportPricingData = ({ filters }: { filters: Record<string, any> }) => {
  const params = new URLSearchParams(filters)
  return Api.get({
    url: `${API_PRICING.PRICING_EXPORT}?${params}`,
  })
}

export {
  fetchPricings,
  getPricingDetails,
  updatePricingDetails,
  importPricingData,
  exportPricingData,
}
